import React from 'react';
import _isNull from 'lodash/isNull';

const utils = {
  scpAppLatestVersion: 'v6.28.0',
  compareVersion: (version1, version2) => {
    const v1Parts = version1
      .replace('v', '')
      .split('.')
      .map(Number);
    const v2Parts = version2
      .replace('v', '')
      .split('.')
      .map(Number);

    for (let i = 0; i < v1Parts.length; i++) {
      if (v1Parts[i] > v2Parts[i]) return 1;
      if (v1Parts[i] < v2Parts[i]) return -1;
    }
    return 0;
  },
  isAllAppVersionsLatest: (minimumVersion, data = []) => {
    if (!data || !Array.isArray(data) || data.length === 0) {
      return true;
    }
    for (const item of data) {
      if (!item.appVersion || _isNull(item.appVersion)) return false;
      if (utils.compareVersion(item.appVersion, minimumVersion) < 0)
        return false;
    }
    return true;
  },
  countOlderAppVersions: (minimumVersion, data) => {
    let count = 0;
    for (const item of data) {
      if (!item.appVersion || _isNull(item.appVersion)) {
        return (count += 1);
      }
      if (utils.compareVersion(item.appVersion, minimumVersion) < 0) {
        return (count += 1);
      }
    }
    return count;
  },
};

export default utils;
